<template>
  <div class="wrapper" @click="send" v-if="editId && user.is_journalist">
    <div v-if="show.error" class="error"><i class="fas fa-times"></i></div>
    <div v-else-if="show.loading" class="loading">
      <div class="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else-if="show.ok" class="ok"><i class="fas fa-check"></i></div>
    <div v-else class="label">{{ label }}</div>
  </div>
</template>

<script>
import { computed, reactive } from "vue";
import { sendMessage } from "@/network/v2";
import { useStore } from "vuex";
export default {
  props: {
    editId: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    activeLang: {
      type: String,
      required: true,
    },
    actionType: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const store = useStore();
    const show = reactive({
      loading: false,
      error: false,
      ok: false,
      spinner: false,
    });

    const send = () => {
      show.loading = true;
      sendMessage(
        (res) => {
          show.ok = res.ok;
          show.loading = false;
        },
        props.editId,
        props.activeLang,
        store.getters.access,
        props.actionType,
        () => {
          show.error = true;
          show.loading = false;
        }
      );
    };
    return {
      user: computed(() => store.getters.user),
      send,
      show,
    };
  },
};
</script>


<style lang="scss" scoped>
.wrapper {
  margin-top: 2vw;
  cursor: pointer;
  width: 11vw;
  height: 3vw;
  .label {
    color: white;
    background: #143f7b;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    width: 12vw;
    height: 3vw;
    font-size: 1vw;
    transition: all 0.4s ease-in-out;
    &:hover {
      color: #143f7b;
      background: transparent;
      border: 1px solid #143f7b;
    }
  }

  &:nth-child(1) {
    margin-left: 2.083vw;
  }
  &:nth-child(3) {
    margin-right: 2.083vw;
  }

  .error {
    background: #ffe7e7;
    color: rgba(210, 0, 1, 1);
    font-size: 1.542vw;
    line-height: 1.25vw;
    border-radius: 10px;
    width: 12vw;
    height: 3vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ok {
    background: #f3ffe4;
    color: #04a701;
    font-size: 1.542vw;
    line-height: 1.25vw;
    border-radius: 10px;
    width: 12vw;
    height: 3vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #143f7b;
    width: 12vw;
    height: 3vw;
    border-radius: 10px;
  }
}

@media screen and (max-width: 1366px) {
  .wrapper {
    margin-top: 8vw;
    margin-bottom: 8vw;
    .label {
      width: 15vw;
      height: 7vw;
      font-size: 1.4vw;
      line-height: 1.8vw;
    }
    .error {
      width: 15vw;
      height: 7vw;
      font-size: 1.8vw;
    }
    .loading {
      width: 15vw;
      height: 7vw;
      font-size: 1.8vw;
    }
    .ok {
      width: 15vw;
      height: 7vw;
      font-size: 1.8vw;
    }

    &:nth-child(1) {
      margin-left: 2.083vw;
    }
    &:nth-child(3) {
      margin-right: 7.083vw;
    }
  }
}
@media screen and (max-width: 414px) {
  .wrapper {
    margin-bottom: 10vw;
    .label {
      width: 24vw;
      height: 10vw;
      font-size: 2.4vw;
      line-height: 1.8vw;
    }
    .error {
      width: 24vw;
      height: 10vw;
      font-size: 2.4vw;
      line-height: 1.8vw;
    }
    .ok {
      width: 24vw;
      height: 10vw;
      font-size: 2.4vw;
      line-height: 1.8vw;
    }
    .loading {
      width: 24vw;
      height: 10vw;
      font-size: 2.4vw;
      line-height: 1.8vw;
    }
    &:nth-child(1) {
      margin-left: 2.083vw;
    }
    &:nth-child(3) {
      margin-right: 16.083vw;
    }
  }
}
</style>
